import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import type { OmicronFakeDoorParams } from 'reactApp/modules/promoNew/types';

export const IS_NEW_PROMO_FD_PARAMS: boolean = isFeature('3promo-fd');
export const NEW_PROMO_FD_PARAMS: OmicronFakeDoorParams = getFeature('3promo-fd') || {};
